/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_increase_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can a percentage increase be more than 100%?`)
};

const es_pct_increase_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Puede un aumento porcentual ser mayor del 100%?`)
};

const de_pct_increase_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann ein prozentualer Anstieg mehr als 100% betragen?`)
};

const nl_pct_increase_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kan een percentagestijging meer dan 100% zijn?`)
};

const fr_pct_increase_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une augmentation en pourcentage peut-elle dépasser 100 % ?`)
};

const it_pct_increase_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un aumento percentuale può essere superiore al 100%?`)
};

const pt_br2_pct_increase_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um aumento percentual pode ser maior que 100%?`)
};

const pt_pct_increase_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um aumento percentual pode ser superior a 100%?`)
};

const ja_pct_increase_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パーセント増加が100%を超えることはありますか？`)
};

const zh_pct_increase_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`百分比增长可以超过 100% 吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_increase_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_increase_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_increase_faq3_q", locale)
	if (locale === "en") return en_pct_increase_faq3_q(inputs)
	if (locale === "es") return es_pct_increase_faq3_q(inputs)
	if (locale === "de") return de_pct_increase_faq3_q(inputs)
	if (locale === "nl") return nl_pct_increase_faq3_q(inputs)
	if (locale === "fr") return fr_pct_increase_faq3_q(inputs)
	if (locale === "it") return it_pct_increase_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_pct_increase_faq3_q(inputs)
	if (locale === "pt") return pt_pct_increase_faq3_q(inputs)
	if (locale === "ja") return ja_pct_increase_faq3_q(inputs)
	return zh_pct_increase_faq3_q(inputs)
};